import { env } from '@/config';

export function uploadData(trackId, type = 'event', customData = {}) {
  // 无trackId 或 mock环境 不上传
  if (!trackId || env === 'mock') return;
  const channel = window.__kaer_config__?.page?.props?.channel;
  // console.log('uploadData', type, { trackId, custom: { channel, ...customData } });
  const service = type === 'event' ? Telescope.trackEvent : Telescope.trackPage;
  service({ trackId, custom: { channel, ...customData } });
}
